import { styled } from '@mui/material'

export const FilesContent = styled('div')({
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column' 
});

export const FileInfo = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%'
});

export const FileName = styled('div')({
  paddingTop: '6px',
  fontSize: '14px',
});

export const FileDescription = styled('div')({
  paddingTop: '6px',
  fontSize: '12px',
});

export const Toolbar = styled('div')({
  padding: '20px',
  margin: 'auto 0 0 0',
  borderTop: 'solid 1px rgba(189, 195, 202, 1)',
});
